export const AJAX = "https://www.sourcejump.net/ajax/"
export const DOMAIN = "https://www.sourcejump.net/"
export const HOME = "https://www.sourcejump.net/"